export const handleErrorCode = (errorCode: string | undefined) => {
  switch (errorCode) {
    case 'GEN0000':
      return "Valor incorrecto para 'CreditProposalId'";
    case 'GEN0001':
      return 'El campo correspondiente no debe ser nulo';
    case 'GEN0002':
      return 'El parámetro indicado en el mensaje de error no cumple con la longitud de los caracteres';
    case 'GEN0003':
      return "El parámetro 'term' debe ser menor o igual que 420 y mayor o igual que 1";
    case 'GEN0009':
      return 'El campo no tiene un valor válido';
    case 'GEN9000':
      return 'Acceso no autorizado';
    case 'CRP0001':
      return 'Campo obligatorio vacío';
    case 'CRP0002':
      return 'Entidad no encontrada';
    case 'CRP0003':
      return 'Campo con valor incorrecto';
    case 'CRP0004':
      return 'Las entidades no están relacionadas';
    case 'CRP0005':
      return 'El intermediario no cumple las condiciones de acceso necesarias';
    case 'CRP0006':
      return 'La propuesta no está en un estado que permita ejecutar esa acción';
    case 'CRP0008':
      return 'Fecha de nacimiento incorrecta. La edad debe estar entre 18 y 85';
    case 'CRP0010':
      return 'El importe de compra no puede ser inferior al importe solicitado';
    case 'CRP0012':
      return 'El importe de compra está fuera del intervalo de importe permitido por la oferta comercial';
    case 'CRP0013':
      return 'El plazo está fuera del conjunto de plazos permitidos por la oferta comercial';
    case 'CRP0016':
      return "El parámetro 'Customer.Phones' debe tener al menos un teléfono";
    case 'CRP0017':
      return "No se permiten más de dos teléfonos en el campo 'Customer.Phones'";
    case 'CRP0018':
      return "El campo 'Customer.Phone' no puede estar repetido";
    case 'CRP0019':
      return "El campo 'Customer.Phone' no es un teléfono válido";
    case 'CRP0021':
      return 'El merchant de la propuesta no es válido';
    case 'CRP0023':
      return 'La plantilla de la propuesta no es válida';
    case 'CRP0027':
      return 'No existe el pago para la propuesta indicada';
    case 'CRP0030':
      return 'La dirección IP indicada no se corresponde con el formato IPv4/IPv6 válido';
    case 'CRP0031':
      return 'Campo con formato incorrecto';
    case 'CRP0035':
      return 'El Documento Personal de la propuesta no coincide con el Documento Personal procesado';
    case 'CRP0036':
      return 'La propuesta tiene que estar activada para guardar su documentación';
    case 'CRP0039':
      return 'Flow incorrecto entre producto y aplicación';
    case 'CRP0040':
      return 'El tipo de documento no es un tipo correcto';
    case 'CRP0041':
      return 'El ocrDocumentId no está vigente; ha sido reemplazado por un intento nuevo';
    case 'CRP0049':
      return 'El pago de la propuesta no está en estado correcto';
    case 'CRP0050':
      return 'El pedido indicado en la creacion de la propuesta ya esta asociado a otra propuesta existente';
    case 'CRP0052':
      return 'La dirección IP indicada no se corresponde con el formato IPv4/IPv6 válido';
    case 'CRP0053':
      return 'La fecha indicada no se corresponde con el formato ISO8601';
    case 'CRP0054':
      return 'La aceptación de condiciones ya fue aprobada para este pedido';
    case 'CRP0055':
      return 'No existe el pedido indicado';
    case 'ESG0009':
      return 'Se ha excedido el número máximo de reenvíos';
    case 'ESG0014':
      return 'El pin introducido no coincide con el generado';
    case 'ESG0015':
      return 'El código pin ha expirado';
    case 'ESG0016':
      return 'No se permiten más reintentos';
    case 'failed':
      return 'Debe introducir el pin que se le ha enviado';
    case 'conditions':
      return 'Debe aceptar las condiciones para continuar';
    default:
      return 'Ha ocurrido un error inesperado';
  }
};
